import { render, staticRenderFns } from "./orderEdit.vue?vue&type=template&id=61fb9cf8&scoped=true&"
import script from "./orderEdit.vue?vue&type=script&lang=tsx&"
export * from "./orderEdit.vue?vue&type=script&lang=tsx&"
import style0 from "./orderEdit.vue?vue&type=style&index=0&id=61fb9cf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fb9cf8",
  null
  
)

export default component.exports